exports.logError = error => {
  console.error(error);
};
